import { Suspense, lazy } from 'react';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';

const SendTestSmsPage = lazy(() =>
  import('@repo/ui/features/sms').then((module) => ({
    default: module.SendTestSmsPage,
  })),
);

export default function SendTestSmsDebugRoute() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement du module SMS debug..." />}>
      <SendTestSmsPage />
    </Suspense>
  );
}
